// Recovered compiled webpack factory 2018. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "pathHasPrefix", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(5240);
  function a(e, t) {
    if ("string" != typeof e) return !1;
    let { pathname: r } = (0, n.parsePath)(e);
    return r === t || r.startsWith(t + "/");
  }
}
